import script from "./incremental-data-provider.vue?vue&type=script&lang=js"
export * from "./incremental-data-provider.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__